/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Daily_CompleteInputs */

const bn_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিদিন সম্পূর্ণ`)
};

const de_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täglich komplett`)
};

const el_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καθημερινή πλήρης`)
};

const en_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily complete`)
};

const es_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diario completo`)
};

const fr_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quotidien terminé`)
};

const hi_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दैनिक पूर्ण`)
};

const hu_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napi teljes`)
};

const id_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai setiap hari`)
};

const it_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo giornaliero`)
};

const ja_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日完了`)
};

const ko_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 완료`)
};

const nl_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks compleet`)
};

const pl_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codziennie ukończone`)
};

const pt_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diário completo`)
};

const ru_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежедневное завершение`)
};

const sv_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagligen klar`)
};

const tr_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük tamamlandı`)
};

const uk_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щодня повно`)
};

const vi_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn thành hàng ngày`)
};

const zh_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日完成`)
};

const zh_hant_game_daily_complete = /** @type {(inputs: Game_Daily_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日完成`)
};

/**
* | output |
* | --- |
* | "Daily complete" |
*
* @param {Game_Daily_CompleteInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_daily_complete = /** @type {((inputs?: Game_Daily_CompleteInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Daily_CompleteInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_daily_complete(inputs)
	if (locale === "de") return de_game_daily_complete(inputs)
	if (locale === "el") return el_game_daily_complete(inputs)
	if (locale === "en") return en_game_daily_complete(inputs)
	if (locale === "es") return es_game_daily_complete(inputs)
	if (locale === "fr") return fr_game_daily_complete(inputs)
	if (locale === "hi") return hi_game_daily_complete(inputs)
	if (locale === "hu") return hu_game_daily_complete(inputs)
	if (locale === "id") return id_game_daily_complete(inputs)
	if (locale === "it") return it_game_daily_complete(inputs)
	if (locale === "ja") return ja_game_daily_complete(inputs)
	if (locale === "ko") return ko_game_daily_complete(inputs)
	if (locale === "nl") return nl_game_daily_complete(inputs)
	if (locale === "pl") return pl_game_daily_complete(inputs)
	if (locale === "pt") return pt_game_daily_complete(inputs)
	if (locale === "ru") return ru_game_daily_complete(inputs)
	if (locale === "sv") return sv_game_daily_complete(inputs)
	if (locale === "tr") return tr_game_daily_complete(inputs)
	if (locale === "uk") return uk_game_daily_complete(inputs)
	if (locale === "vi") return vi_game_daily_complete(inputs)
	if (locale === "zh") return zh_game_daily_complete(inputs)
	return zh_hant_game_daily_complete(inputs)
});